import * as React from 'react';
import {YearMonth, YearMonthRangePicker} from "./utils/YearMonthRangePicker";
import SectionHeaderFormItem from "../common/form-items/SectionHeaderFormItem";
import locales from "../locales";
import {TypeValue} from "../api/dtos/statistics";
import {
  renderLegendDot,
  renderPercentTextIfPossible,
  renderPriceStatLayoutItem,
  renderStatLayoutItem,
  renderTitledStatLayout
} from "./utils/statistics-utils";
import {ChartItem, RentimeChart} from "./RentimeChart";
import {groupNumber, withCurrency} from "../utils/number-utils";
import {getColor} from "./utils/statistics-colors";
import {Alert} from "antd";

interface Props {
  onQueryParamsChange: (start: YearMonth, end: YearMonth) => void;
  typeCostStatistics?: TypeValue[];
}

interface State {
  start?: YearMonth;
  end?: YearMonth;
}

export default class IncomingInvoiceTypeDistributionStatisticsPanel extends React.Component<Props, State> {

  public render(): React.ReactNode {
    const {typeCostStatistics} = this.props;
    const noStatsAvailable = typeCostStatistics && typeCostStatistics.length === 0;
    return (
      <>
        <SectionHeaderFormItem title={locales.range}/>
        <YearMonthRangePicker
          onRangeClear={this.onRangeClear}
          onRangePick={this.onRangePick}
        />

        {noStatsAvailable && this.renderNoStatisticsAvailable()}
        {!noStatsAvailable && typeCostStatistics && this.renderCostStatistics(typeCostStatistics)}
      </>
    );
  }

  private onRangeClear = () => {
    this.setState({
      start: undefined,
      end: undefined,
    });
  };

  private onRangePick = (start: YearMonth | undefined, end: YearMonth | undefined) => {
    this.setState({start, end});
    if (start && end) {
      this.props.onQueryParamsChange(start, end)
    }
  };

  private renderNoStatisticsAvailable = (): React.ReactNode => {
    return renderTitledStatLayout('', renderStatLayoutItem('', <Alert type="info"
                                                                      message={locales.statistics_no_data}/>));
  };

  private renderCostStatistics = (stats: TypeValue[]): React.ReactNode => {
    const chartData = this.mapStatsToChartData(stats);
    const totalCost = stats.map(s => s.sum).reduce((a, b) => a + b, 0);

    return renderTitledStatLayout(
      locales.incoming_invoices,
      <>
        <b>{renderPriceStatLayoutItem(locales.total_cost, totalCost)}</b>
        {stats.map((stat, index) => this.renderTypeCostStat(stat, totalCost, index))}
      </>,
      <>
        {totalCost > 0 && <RentimeChart unit={locales.app_currency} data={chartData}/>}
      </>
    );
  };

  private renderTypeCostStat = (stat: TypeValue, total: number, index: number) => {
    return renderStatLayoutItem(
      stat.type,
      <>
        {renderLegendDot(getColor(index))}
        {withCurrency(groupNumber(stat.sum))}
        {renderPercentTextIfPossible(stat.sum, total)}
      </>
    );
  };

  private mapStatsToChartData = (stats: TypeValue[]): ChartItem[] => {
    return stats.map(stat => {
      return {
        name: stat.type,
        value: stat.sum
      };
    });
  };
}


// WEBPACK FOOTER //
// ./src/statistics/IncomingInvoiceTypeDistributionStatisticsPanel.tsx